import angular from 'angular';

class LoginCtrl {
    /*@ngInject*/
    constructor($rootScope, AUTH_EVENTS, AuthSvc, toastr) {
        this.$rootScope = $rootScope;
        this.AUTH_EVENTS = AUTH_EVENTS;
        this.AuthSvc = AuthSvc;
        this.toastr = toastr;
    }

    $onInit() {
        let vm = this;

        // Init des données
        vm.credentials = {
            username: '',
            password: ''
        };

        vm.login = login;

        ////////////////
        function login() {
            vm.AuthSvc.login(vm.credentials.username, vm.credentials.password).then(
                function(user) {
                    vm.$rootScope.$broadcast(vm.AUTH_EVENTS.loginSuccess, user);

                    vm.AuthSvc.redirectToAttemptedState();
                },
                function() {
                    vm.$rootScope.$broadcast(vm.AUTH_EVENTS.loginFailed);
                    vm.toastr.error('Authentification', "Echec d'authentification");
                }
            );
        }
    }
}

angular.module('app.login').component('login', {
    templateUrl: require('./login.html'),
    controller: LoginCtrl
});
